export default __webpack_public_path__ + "static/TSD_Blog_Overview_Holiday_Shopping_Season_2-4cde125b74f93f391e933c08a128a0a5.jpg";